import { useState, useEffect } from "react";
import { Capacitor } from "@capacitor/core";
import { Keyboard } from "@capacitor/keyboard";

/**
 * Global keyboard height for use in modals and forms.
 * Ensures inputs are never covered by the keyboard on native.
 */
export function useKeyboardHeight() {
  const [keyboardHeight, setKeyboardHeight] = useState(0);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;
    const isIOS = Capacitor.getPlatform() === "ios";
    const showEvent = isIOS ? "keyboardWillShow" : "keyboardDidShow";
    const hideEvent = isIOS ? "keyboardWillHide" : "keyboardDidHide";
    let cancelled = false;
    const listeners: { remove: () => Promise<void> }[] = [];
    void (async () => {
      const [show, hide] = await Promise.all([
        Keyboard.addListener(showEvent as "keyboardWillShow", (info: { keyboardHeight: number }) => {
          if (!cancelled) setKeyboardHeight(info.keyboardHeight);
        }),
        Keyboard.addListener(hideEvent as "keyboardWillHide", () => {
          if (!cancelled) setKeyboardHeight(0);
        }),
      ]);
      if (!cancelled) listeners.push(show, hide);
      else {
        show.remove();
        hide.remove();
      }
    })();
    return () => {
      cancelled = true;
      listeners.forEach((l) => l.remove());
    };
  }, []);

  return keyboardHeight;
}
